import React from "react";
import "./Style.css";

const OurServices = () => {
  const items = [
    { title: "European Standards" },
    { title: "Gulf Standards" },
    { title: "Asian Standards" },
    { title: "Middle-East Standards" },
  ];

  return (
    <div className="standards-wrapper">
      <div className="standards-logo">
        <h1>SGS</h1>
        <div className="underline"></div>
      </div>

      <p className="subtitle">
        <span className="icon">🌐</span> International Standards
      </p>

      <h2 className="main-title">We Provide International Standards</h2>

      <div className="standards-grid">
        {items.map((item, index) => (
          <div key={index} className="standard-card">
            <span className="globe-emoji">🌍</span>
            <h3>{item.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurServices;
